import CustomModal from "./custom-modal.component";

export default CustomModal